import type {PropsWithChildren} from 'react'
import {Box} from '@primer/styled-react'

export default function Content({children}: PropsWithChildren) {
  return <Box sx={{mt: 1, fontSize: 1}}>{children}</Box>
}
